import { Component, defineComponent } from '@decify/cell-shopify/client';
import './InfoBar.scss';
export const infoBarName = 'InfoBar';
export const infoBarTagName = 'cell-component-info-bar';
export class InfoBar extends Component {
    constructor() {
        super(infoBarName);
        this.handleClick = this.handleClick.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.showTooltip = this.showTooltip.bind(this);
        this.hideTooltip = this.hideTooltip.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    componentDidMount() {
        this.subscribe('click', this.handleClick);
    }
    handleClick() {
        if (this.classList.contains('InfoBar--TooltipVisible')) {
            this.hideTooltip();
        }
        else {
            this.showTooltip();
        }
    }
    showTooltip() {
        this.classList.add('InfoBar--TooltipVisible');
        window.addEventListener('click', this.handleClickOutside);
        window.addEventListener('scroll', this.handleScroll, { once: true });
    }
    hideTooltip() {
        this.classList.remove('InfoBar--TooltipVisible');
        window.removeEventListener('click', this.handleClickOutside);
        window.removeEventListener('scroll', this.handleScroll);
    }
    handleScroll() {
        this.hideTooltip();
    }
    handleClickOutside(event) {
        if (!this.contains(event.target)) {
            this.hideTooltip();
        }
    }
}
defineComponent(infoBarTagName, InfoBar);
